import paramsHelper from '../helpers/params'

import { onlineModules, bookingTerminalPlanningTypes, billingModeTypes, billImageOptions, sageExportTypes } from '../ui/params'

export default {
    data: () => ({onlineModules, bookingTerminalPlanningTypes, billingModeTypes, billImageOptions, sageExportTypes}),
    methods: paramsHelper
}
